import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { ProductDataStore } from "../../../shared/providers/productData";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { ListModelCacheService } from "../providers/listModelCacheService";
import { PopupService } from "../../../../shared/components/popup/popupService";
import { GlobalDataStore } from "../../../shared/providers/globalData/globalDataStore";
import { PopoverService } from "../../../../shared/components";
import { BaseDetailItemComponent } from "../shared/baseDetailItemComponent";
import { Form, ConfUIItem, GroupConfUIItem, RequestViews, PageLocation } from "../../../shared/models";

@Component({
  selector: 'form-detail',
  templateUrl: './formDetailComponent.html'
})
export class FormDetailComponent extends BaseDetailItemComponent {

  forms: Array<Form>;
  actionBoxTitle: string;
  showInlineTitle: boolean = false;
  RequestViews = RequestViews;

  constructor(@Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(ProductDataStore) public productStore: ProductDataStore,
    
  ) {
    super(confPageSessionService);
  }

  onDataReady(): void {

    this.forms = [];
    this.actionBoxTitle = "";

    if (this.confUIItem) {
      if (this.confUIItem.items) {
        if (this.confUIItem.id) {
          this.addForm(this.confUIItem);
        }
        else
          this.confUIItem.items.forEach(uiItem => {
            this.addForm(uiItem);
          });
      }
    }

    this.visible = this.forms.length > 0;
    if (!this.visible)
      return;

    this.showInlineTitle = this.forms.length > 1;

    if (!this.showInlineTitle) {
      let firstPanel = this.forms[0];
      if (firstPanel.title && firstPanel.title.trim().length > 0)
        this.actionBoxTitle = firstPanel.title;
      // For individually displayed panel if there is no title then hide the whole header row
      else if (typeof this.confUIItem != typeof GroupConfUIItem)
        this.showHeader = false;
    }
  }

  addForm(x: ConfUIItem) {
    const visualObject = this.productStore.getEntity(x.id);

    if (visualObject instanceof Form) {

      let form = visualObject as Form;

      const displayStyle = form.pageLocation as PageLocation;

      if (displayStyle == PageLocation.Tab)
        this.forms.push(form);
     
    }
  }

}